module.exports = __webpack_public_path__ + "img/voice-nor.5a2e4307.svg";